import AgeSettings from './AgeSettings'
import LocationSettings from './Location'
import GenderSettings from './GenderSettings'
import DeviceSettings from './DeviceSettings'
import FacebookFansSettings from './FacebookFansSettings'
import PlatformPlacementsSettings from './Placements'
import InstagramFansSettings from './InstagramFansSettings'
import EventTypeSettings from './EventTypeSettings'
import HypothesisAudienceNotice from './HypothesisAudienceNotice'
import LanguageSettings from './LanguageSettings'
import { isPublishedAdSetInEdit } from '@/pages/campaigns/edit/utils/adCampaignEditWizardInitialState'

const Settings = ({
    stage,
    audience,
    selectedAudience,
    isWorldwideTargeting,
    metricsLoading,
    refetchMetrics,
    formatMetricValue,
    fetchError,
    allMetricsData,
    getStepContentData,
    setStepContentData,
}) => {
    const campaignObjectiveData = getStepContentData('campaignObjective') || {}
    const selectedObjective = campaignObjectiveData.selectedObjective?.toLowerCase()
    // Event type and recency only apply when an audience is created, so a published ad set shows them read-only
    const audienceCreationSettingsReadOnly = isPublishedAdSetInEdit(
        getStepContentData('prefetchedData'),
        stage,
        audience,
    )

    return (
        <>
            <HypothesisAudienceNotice audienceId={audience} getStepContentData={getStepContentData} />
            <div className="tw:grid tw:grid-cols-2 tw:gap-5 tw:pb-5">
                <div className="tw:flex tw:flex-col tw:gap-5">
                    <FacebookFansSettings
                        stage={stage}
                        audience={audience}
                        selectedAudience={selectedAudience}
                        readOnly={audienceCreationSettingsReadOnly}
                    />
                    <InstagramFansSettings
                        stage={stage}
                        audience={audience}
                        selectedAudience={selectedAudience}
                        readOnly={audienceCreationSettingsReadOnly}
                    />
                    <GenderSettings
                        stage={stage}
                        audience={audience}
                        metricsDataLoading={metricsLoading}
                        formatMetricValue={formatMetricValue}
                        metricsData={allMetricsData?.genderMetrics}
                        getStepContentData={getStepContentData}
                        setStepContentData={setStepContentData}
                    />
                    <AgeSettings
                        stage={stage}
                        audience={audience}
                        metricsDataLoading={metricsLoading}
                        refetchMetrics={refetchMetrics}
                        formatMetricValue={formatMetricValue}
                        fetchError={fetchError}
                        metricsData={allMetricsData?.ageMetrics}
                        getStepContentData={getStepContentData}
                        setStepContentData={setStepContentData}
                    />

                    {isWorldwideTargeting && (
                        <LocationSettings
                            stage={stage}
                            audience={audience}
                            metricsDataLoading={metricsLoading}
                            formatMetricValue={formatMetricValue}
                            metricsData={allMetricsData?.countryMetrics}
                            getStepContentData={getStepContentData}
                            setStepContentData={setStepContentData}
                        />
                    )}
                </div>

                <div className="tw:flex tw:flex-col tw:gap-5">
                    {['leads', 'sales'].includes(selectedObjective) && (
                        <EventTypeSettings
                            stage={stage}
                            audience={audience}
                            getStepContentData={getStepContentData}
                            setStepContentData={setStepContentData}
                            readOnly={audienceCreationSettingsReadOnly}
                        />
                    )}
                    <div>
                        <DeviceSettings
                            stage={stage}
                            audience={audience}
                            metricsDataLoading={metricsLoading}
                            refetchMetrics={refetchMetrics}
                            formatMetricValue={formatMetricValue}
                            fetchError={fetchError}
                            metricsData={allMetricsData?.deviceMetrics}
                            getStepContentData={getStepContentData}
                            setStepContentData={setStepContentData}
                        />
                        <PlatformPlacementsSettings
                            stage={stage}
                            audience={audience}
                            metricsDataLoading={metricsLoading}
                            refetchMetrics={refetchMetrics}
                            formatMetricValue={formatMetricValue}
                            fetchError={fetchError}
                            platformMetricsData={allMetricsData?.platformMetrics}
                            placementMetricsData={allMetricsData?.placementMetrics}
                            getStepContentData={getStepContentData}
                            setStepContentData={setStepContentData}
                        />
                    </div>
                    <LanguageSettings stage={stage} audience={audience} getStepContentData={getStepContentData} />
                </div>
            </div>
        </>
    )
}

export default Settings
